<template>
  <div v-if="loading">
    <div class="top-bar">
      <!-- BEGIN: Breadcrumb -->
      <div class="-intro-x breadcrumb mr-auto hidden-xs">
        <a href="#" class="hidden-xs">MyInxait</a>
      </div>
      <!-- END: Breadcrumb -->

      <div
        class="intro-x dropdown mr-auto sm:mr-6"
        v-if="[2, 3, 4, 5].includes(user.role)"
      >
        <select
          class="input w-full border mt-2 flex-1"
          @change="changeAccount($event)"
          v-model="session_account_current"
          required
        >
          <option
            v-for="account in user.accounts"
            :value="account.id"
            :key="`account-${account.id}`"
          >
            {{ account.name }} - <b>{{ account.prefix }}</b>
          </option>
        </select>
      </div>
      <div
        class="intro-x dropdown mr-auto sm:mr-6"
        v-if="
          [2, 3, 4, 5].includes(user.role) &&
          !['calendar', 'emails', 'campaigns'].includes($route.name)
        "
      >
        <select
          class="input w-full border mt-2 flex-1"
          @change="changeTeam($event)"
          v-model="session_team_current"
          required
        >
          <option
            v-for="team in filteredTeams"
            :value="team.id"
            :key="`team-${team.id}`"
          >
            {{ team.name }}
          </option>
        </select>
      </div>

      <div class="intro-x dropdown mr-auto sm:mr-2">
        <a
          :href="`/activities`"
          target="_blank"
          class="dropdown-toggle notification cursor-pointer flex gap-1"
        >
          <div
            class="flex mt-1 gap-1 border-theme-1 zoom-in py-1 px-2 text-theme-1 rounded-full border border-white z-50"
          >
            <app-icon name="activities" classname="notification__icon" />
            <span class="hidden sm:block">Actividades</span>
          </div>
        </a>
      </div>

      <div class="intro-x dropdown mr-auto sm:mr-2">
        <a
          href="/rrhh"
          target="_blank"
          class="dropdown-toggle notification cursor-pointer flex gap-1"
        >
          <div
            class="flex mt-1 gap-1 border-theme-1 text-theme-1 zoom-in py-1 px-2 rounded-full border z-50"
          >
            <app-icon name="newspaper" classname="notification__icon" />
            <span class="hidden sm:block">Solicitudes</span>
          </div>
        </a>
      </div>

      <!-- <div
        class="intro-x dropdown mr-auto sm:mr-6"
        @mouseover="btn_calendar = true"
        @mouseleave="btn_calendar = false"
      >
        <router-link
          :to="'/admin/calendar/' + user.slug"
          class="dropdown-toggle notification cursor-pointer flex gap-1"
        >
          <app-icon name="calendar" classname="notification__icon" />
          <div
            class="fixed bg-theme-1 py-1 px-2 text-white rounded border border-white z-50 -mt-8 ml-2"
            v-if="btn_calendar"
          >
            Calendarío
          </div>
        </router-link>
      </div> -->

      <!-- BEGIN: Notifications -->
      <div class="intro-x dropdown mr-auto sm:ml-4 sm:mr-2 hidden-xs">
        <div
          class="dropdown-toggle notification cursor-pointer"
          @mouseover="btn_noti = true"
          @mouseleave="btn_noti = false"
          :class="{
            'notification--bullet': filteredNotificationsNotViews.length,
          }"
        >
          <app-icon
            :name="'bell'"
            :classname="'notification__icon text-theme-1'"
          ></app-icon>
          <div
            class="fixed bg-theme-1 py-1 px-2 text-white rounded border border-white z-50 -mt-12 -ml-24 mr-2"
            v-if="btn_noti"
          >
            Notificaciones
          </div>
        </div>
        <div
          class="notification-content dropdown-box mt-8 absolute top-0 left-0 sm:left-auto sm:right-0 z-20 -ml-10 sm:ml-0"
        >
          <div class="notification-content__box dropdown-box__content box">
            <div class="flex justify-between">
              <div class="notification-content__title mb-0">Notificaciones</div>
              <div
                @click="readAllNotifications()"
                class="hover:text-blue-600 hover:underline cursor-pointer text-xs"
                v-if="filteredNotificationsNotViews.length > 0"
              >
                Marcar todas como leidas
              </div>
            </div>
            <div class="box-notifications">
              <div
                class="border-t-2 flex items-center pt-1 relative"
                v-for="notification in filteredNotifications"
                :key="`notification-${notification.id}`"
              >
                <div class="ml-2 overflow-hidden w-full mb-2">
                  <div class="flex items-center">
                    <div
                      class="text-xs text-gray-500 ml-auto whitespace-no-wrap courser-not"
                    >
                      {{ notification.created_at }}
                    </div>
                  </div>
                  <div
                    @click="updateNotification(notification)"
                    :class="{
                      'text-gray-600': notification.view == 1,
                      'text-blue-600': notification.view == 0,
                    }"
                    class="w-full cursor-pointer"
                  >
                    {{ notification.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Notifications -->

      <div
        class="intro-x dropdown mr-auto sm:ml-2 sm:mr-4 hidden-xs cursor-pointer"
        @click="changeTheme"
      >
        <app-icon
          v-show="isDark"
          name="sun"
          classname="notification__icon text-theme-1"
        />
        <app-icon
          v-show="!isDark"
          name="moon"
          classname="notification__icon text-theme-1"
        />
      </div>

      <!-- BEGIN: Account Menu -->
      <div class="intro-x dropdown w-8 h-8 relative">
        <div
          class="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
        >
          <img alt="Profile" :src="user.avatar" v-if="user.avatar" />
          <img alt="Profile" src="/static/FAVICON-2026.png" v-else />
        </div>
        <div class="dropdown-box mt-10 absolute w-56 top-0 right-0 z-20">
          <div class="dropdown-box__content box bg-theme-38 text-white">
            <div class="p-4 border-b border-theme-40">
              <div class="font-medium flex">
                {{ user.name }}
              </div>
              <div class="text-xs">{{ user.email }}</div>
              <div class="text-xs" v-if="user.team">
                {{ user.team.name }}
              </div>
            </div>
            <div class="p-2">
              <router-link
                to="/admin/profile"
                class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md"
              >
                <app-icon name="user" classname="w-4 h-4 mr-2"></app-icon>
                Perfil
              </router-link>
            </div>
            <div class="p-2">
              <router-link
                to="/admin/accounts-auth"
                class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md"
              >
                <app-icon name="folder" classname="w-4 h-4 mr-2"></app-icon>
                Cuentas
              </router-link>
            </div>
            <div class="p-2">
              <router-link
                to="/admin/notes"
                class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md"
              >
                <app-icon name="edit" classname="w-4 h-4 mr-2"></app-icon>
                Mis Notas
              </router-link>
            </div>
            <div class="p-2" v-if="session_team_current == 1 || user.role == 1">
              <router-link
                to="/admin/developments"
                class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md"
              >
                <app-icon name="code" classname="w-4 h-4 mr-2"></app-icon>
                Desarrollos
              </router-link>
            </div>
            <div class="p-2 border-t border-theme-40">
              <a
                @click="doLogout"
                class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md"
              >
                <app-icon
                  name="toggle-right"
                  classname="w-4 h-4 mr-2"
                ></app-icon>
                Salir
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Account Menu -->
      <app-alerts category="Anuncios"></app-alerts>
    </div>

    <div v-if="birthday">
      <div
        class="birthday rounded py-2 px-4 shadow-lg bg-white flex justify-between"
      >
        <div class="text-lg text-theme-10 font-bold bg-white">
          ¡Feliz cumpleaños {{ user.name }} !
        </div>
        <a
          :href="user.prize"
          target="_blank"
          class="bg-theme-10 rounded text-white font-bold p-1 text-center"
          v-if="user.prize"
          >REDIMIR BONO</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Alerts from '@/components/admin/partials/Alerts'

export default {
  name: 'Top',
  data() {
    return {
      loading: false,
      task_notification: {
        entity: 'notification',
        view: 1,
      },
      birthday: false,
      btn_calendar: false,
      btn_noti: false,
    }
  },
  async beforeMount() {
    try {
      //console.log('------------start-top--------------')
      let query = `user_id=true`
      this.getList(['notification', query])
      this.getList('team')
      //console.log('------------end-top--------------')
      this.loading = true
    } catch (error) {}
    this.searchBirthday()
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      notifications: 'getNotifications',
      teams: 'getTeams',
      session_account_current: 'getSessionAccount',
      session_team_current: 'getSessionTeam',
    }),
    filteredNotifications: function () {
      return this.notifications.filter((item) => {
        if (item.user_id == this.user.id) {
          return item
        }
      })
    },
    filteredNotificationsNotViews: function () {
      return this.notifications.filter((item) => {
        if (item.user_id == this.user.id && item.view == 0) {
          return item
        }
      })
    },
    filteredTeams: function () {
      return this.teams.filter((item) => {
        return [1, 2, 3, 5].includes(item.id)
      })
    },
    isDark: {
      get() {
        return this.$store.state.isDarkMode
      },
      set(value) {
        // El set se realiza a través de la acción
      },
    },
  },
  created() {},
  methods: {
    doLogout() {
      this.logout(this.user).then((log) => {
        this.$router.replace(this.$route.query.redirect || '/')
      })
    },
    ...mapMutations(['SESSION_ACCOUNT', 'SESSION_TEAM']),
    ...mapActions(['get', 'getAll', 'getList', 'logout', 'update']),
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some((path) => {
        return this.$route.path.indexOf(path) == 0
      })
    },
    changeAccount(e) {
      localStorage.session_account = e.target.value
      this.SESSION_ACCOUNT(e.target.value)
      this.reloadWithoutParameters()
    },
    changeTeam(e) {
      localStorage.session_team = e.target.value
      this.SESSION_TEAM(e.target.value)
      this.reloadWithoutParameters()
    },
    updateNotification(value) {
      var vm = this
      vm.loading = false
      vm.task_notification.id = value.id
      vm.update(vm.task_notification)
        .then((item) => {
          vm.loading = true
          if (value.url) {
            window.location.href = value.url
          }
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    async readAllNotifications() {
      this.loading = true
      try {
        await this.get(`notification/read-all`).then((data) => {
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        })
      } catch (error) {
        window.$toast.error(error)
      } finally {
        this.loading = false
      }
    },
    reload() {
      window.location.reload()
    },
    reloadWithoutParameters() {
      window.location = window.location.href.split('?')[0]
    },
    searchBirthday() {
      var user = this.user
      if (user) {
        var birthday = user.birthday
        var today = new Date()
        let mm = today.getMonth() + 1 // Months start at 0!
        let dd = today.getDate()

        if (dd < 10) dd = '0' + dd
        if (mm < 10) mm = '0' + mm

        var today_date = mm + '-' + dd
        if (birthday) {
          var birthday_date = birthday.substr(5, 5)

          if (birthday_date == today_date) {
            this.birthday = true
          }
        }
      }
    },
    changeTheme() {
      // Llamamos a la acción de vuex
      this.$store.dispatch('toggleTheme')
    },
  },
  components: {
    appIcon: Icon,
    appAlerts: Alerts,
  },
}
</script>



// WEBPACK FOOTER //
// Top.vue?b7b56cc8